module.exports = __webpack_public_path__ + "static/media/notable-trait.5db44568.svg";